import config from '@feature-config/game/kingdom/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { KingdomFeature } from './KingdomFeature';

const kingdomFeature: FeatureModule = createFeatureModule(
  config,
  KingdomFeature,
  'game/kingdom'
);

export default kingdomFeature;
